<template>
  <div class="step4">
    <h2 class="access_hidden">신청완료</h2>
    <h3>포인트 전환 신청이 완료되었습니다</h3>
    <p>
      현금 캐시백은 익월 1~15일 이내 승인을 거쳐 입력하신 계좌로 입금되며, 진행 상황은 포인트 전환 내역에서 확인해주세요
    </p>
    <div class="bt">
      <v-button @handleClick="handleClick()" class="btn01" text="포인트 전환 내역 보기" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import eventBus from '@/utils/eventBus';

export default {
  components: {
    VButton,
  },
  computed: {
    ...mapGetters(['isExchangeIframe']),
  },
  created() {
    if (this.$route.params.serviceUrl) {
      this.setServiceUrl(this.$route.params.serviceUrl);
    }
    eventBus.$emit('scrollUpdate');
  },
  methods: {
    ...mapActions(['setServiceUrl']),
    handleClick() {
      if (this.isExchangeIframe) {
        window.parent.postMessage({ event: 'iframeClose', data: null }, '*');
      } else {
        this.$router.replace({ name: 'ExchangeHistory' });
      }
      // window.opener.location.href = "/kr/cso-coin/exchangeHistory"
      // window.close()
    },
  },
};
</script>
